import { useParams } from "react-router-dom";
import { useAmendmentsStore } from "@/features/journal-version-list";
import { useNavigationPosition } from "@/shared/lib/hooks";

export const useTitleAmendmentMode = () => {
  const { requestId } = useParams<{ requestId?: string }>();
  const { isTitleAmendmentsForm } = useNavigationPosition();
  const request = useAmendmentsStore((state) =>
    requestId
      ? state.requests.find((item) => item.key === requestId)
      : undefined,
  );

  return {
    isTitleAmendmentsForm,
    isNewAmendment:
      isTitleAmendmentsForm &&
      request?.status === "NEW" &&
      request.requestSource !== "SYSTEM",
  };
};
